import Styled from './styled'
import { useState } from 'react'
import { useAsync } from 'react-use'
import moment from 'moment'
//Components
import { Space, notification, DatePicker, Typography, Row, Col } from 'antd'
import Select from 'components/Select'
import Button from 'components/Button'
import Card from 'components/Card'
import { useTranslate } from 'hooks/translate'
import Table from 'components/Table'
import Page from 'components/Page'
import { useParams } from 'react-router-dom'
//Service
import { getAllUser } from 'services/user'
import { getAuditLog, exportAuditLog } from 'services/eventTracking'
import { getActionTypeApi } from 'services/filter/actionType'

const DEFAULT_PAGE_SIZE = 20
const { RangePicker } = DatePicker
const DATE_FORMAT = 'YYYY-MM-DD'

export default function PageEventTracking () {
  const { report_code } = useParams()
  const { t } = useTranslate()
  const [userDropdown, setUserDropdown] = useState([])
  const [actionTypeDropdown, setActionTypeDropdown] = useState([])
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [filters, setFilters] = useState({
    start_date: null,
    end_date: null,
    log_activity_type: null,
    action_user: null,
    report_header_id: null,
    toppic_code: report_code ? report_code : null,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
  })

  const columns = [
    {
      title: t('Incident Code'),
      dataIndex: 'incident_code',
      key: 'incident_code',
      width: 200,
      sorter: (a, b) => {
        return `${a?.reportcode_cd || ''}`.localeCompare(`${b?.reportcode_cd || ''}`)
      },
      render: (text, data, index) => {
        return (
          <div>
            <p>
              {t('Report Code')}:{data.reportcode_cd}
            </p>
            <p>
              {t('Investigate Code')}:{data.investigatecode_cd}
            </p>
          </div>
        )
      },
    },
    {
      title: t('Incident'),
      dataIndex: 'incident_topic',
      key: 'incident_topic',
      width: 200,
      sorter: (a, b) => {
        return `${a?.incident_topic || ''}`.localeCompare(`${b?.incident_topic || ''}`)
      },
      render: (text, data, index) => {
        return (
          <div>
            <p>
              {t('Incident Topic')}:{data.incident_topic}
            </p>
            <p>
              {t('Status')}:{data.report_status}
            </p>
          </div>
        )
      },
    },
    {
      title: t('Action Type'),
      dataIndex: 'log_activity_type',
      key: 'log_activity_type',
      width: 100,
      sorter: (a, b) => {
        return `${a?.log_activity_type || ''}`.localeCompare(`${b?.log_activity_type || ''}`)
      },
    },
    {
      title: t('Description'),
      dataIndex: 'log_activity_description',
      key: 'log_activity_description',
      width: 200,
      render: (text, data, index) => {
        return (
          <div>
            {text.split('\n').map((item, i) => (
              <p key={i}>{item}</p>
            ))}
          </div>
        )
      },
    },
    {
      title: t('Datetime'),
      dataIndex: 'action_datetime',
      key: 'action_datetime',
      width: 180,
      sorter: (a, b) => {
        return `${a?.action_datetime || ''}`.localeCompare(`${b?.action_datetime || ''}`)
      },
    },
    {
      title: t('User'),
      dataIndex: 'action_user',
      key: 'action_user',
      width: 200,
      sorter: (a, b) => {
        return `${a?.action_user || ''}`.localeCompare(`${b?.action_user || ''}`)
      },
    },
  ]

  const _list = async () => {
    const res = await getAuditLog(filters)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })
      return
    }

    const tempData = []
    res?.data?.items.map((item) => {
      tempData.push({
        audit_log_id: item?.audit_log_id,
        reportcode_cd: item?.report_header?.investigatecode_cd,
        investigatecode_cd: item?.report_header?.investigatecode_cd,
        incident_topic: item?.report_header?.incident_topic,
        report_status_name: item?.report_header?.report_status?.report_status_name_en,
        log_activity_type: item?.activity_type?.value_list_name,
        log_activity_description: item?.log_activity_description,
        action_datetime: moment(item?.action_datetime).format('YYYY-MM-DD HH:mm:ss'),
        action_user: item?.user?.employee?.employee_name_en,
      })
    })

    setTotal(res.data.total)

    setDataSource(tempData)
  }

  const getUserDropdown = async () => {
    const res = await getAllUser()

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })
      return
    }

    const tempData = []
    res.data.map((item) => {
      tempData.push({
        label: item?.employee.employee_name_th,
        value: item?.user_id,
      })
    })

    setUserDropdown(tempData)
  }

  const getActionTypeDropdown = async () => {
    const res = await getActionTypeApi()

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })
      return
    }

    setActionTypeDropdown(res.data)
  }

  const exportExcel = async () => {
    const res = await exportAuditLog(filters)

    // if (res.status === 'error') {
    //   notification.error({
    //       message: 'Failed',
    //       description: res.message,
    //     })
    //   return
    // }

    // return res.data
  }

  useAsync(async () => {
    _list()
    getActionTypeDropdown()
    getUserDropdown()
  }, [filters])

  return (
    <Styled className='page page-event-tracking'>
      <Page
        title={t('Audit Log')}
        showSearch={true}
        searchPlaceholder={t('Search Incident Topic')}
        onSearch={(value) => {
          setFilters({
            ...filters,
            toppic_code: value,
            page: 1,
          })
        }}
      ></Page>

      {/* filter */}
      <div style={{ marginBottom: 16 }}>
        <span>
          <Space>
            <Row gutter={[8, 8]}>
              <Col xs={24} lg={12}>
                <Select
                  placeholder={t('User')}
                  options={userDropdown}
                  onChange={(value) => {
                    setFilters({
                      ...filters,
                      action_user: value,
                      page: 1,
                    })
                  }}
                />
              </Col>
              <Col xs={24} lg={12}>
                <Select
                  placeholder={t('Action Type')}
                  options={actionTypeDropdown}
                  onChange={(value) => {
                    setFilters({
                      ...filters,
                      log_activity_type: value,
                      page: 1,
                    })
                  }}
                />
              </Col>
              <Col xs={24} lg={12}>
                <RangePicker
                  allowClear={true}
                  format={DATE_FORMAT}
                  onChange={(value) => {
                    setFilters({
                      ...filters,
                      start_date: value == null ? null : value[0].format(DATE_FORMAT),
                      end_date: value == null ? null : value[1].format(DATE_FORMAT),
                      page: 1,
                    })
                  }}
                />
              </Col>
              <Col span={24}>
                <Button
                  type='primary'
                  size='middle'
                  onClick={() => {
                    exportExcel()
                  }}
                >
                  {t('Export')}
                </Button>
              </Col>
            </Row>
          </Space>
        </span>
        <span style={{ float: 'right' }}></span>
      </div>

      <Card>
        <Table
          className='macth'
          tableLayout='fixed'
          columns={columns}
          dataSource={dataSource}
          pagination={{
            current: filters.page,
            pageSize: filters.size,
            total: total,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total) => t('Total ${total} items', { total }),
          }}
          onChange={(pagination) => {
            setFilters({
              ...filters,
              page: pagination.current,
              size: pagination.pageSize,
            })
          }}
          rowKey={'audit_log_id'}
          sticky
          scroll={{ x: 1200 }}
        ></Table>
      </Card>
    </Styled>
  )
}
